import Error from './Error.component'

export default Error
